import {
  ComponentName,
  getPluginComponentSetting
} from "@/utils/vue-tailwind.utils";
import { TCard } from "vue-tailwind/dist/components";

const CardVTComponentSetting = getPluginComponentSetting({
  componentName: ComponentName.TCard,
  vueTailwindComponent: TCard,
  props: {
    fixedClasses: {
      wrapper: "",
      header: "",
      footer: ""
    },
    classes: {
      wrapper: "bg-white",
      body: "",
      header: "bg-gray-100",
      footer: "bg-gray-100"
    }
  }
});

export default CardVTComponentSetting;
